export const InputGroup = styled.div`
  margin-bottom: 20px;
`;

export const MinimumForm = styled.div`
  min-height: 600px;
`;
